import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';

const disclosureCount = createSlice({
  name: 'disclosureCount',
  initialState,
  reducers: {
    addConditionDisclosureCount: (state, action) => {
      return {
        ...state,
        CONDITION: {
          count: action.payload.condition
        }
      };
    },
    addHistoryDisclosureCount: (state, action) => {
      return {
        ...state,
        VEHICLEHISTORY: {
          count: action.payload.vehiclehistory
        }
      };
    }
  }
});

export default disclosureCount;
